import { createMediaButton } from "../create-media-button.js";
import { CaptionsButtonCore, CaptionsButtonDataAttrs } from "@videojs/core";
import { selectTextTrack } from "@videojs/core/dom";
//#region src/ui/captions-button/component.tsx
/** A button that toggles captions. */
const CaptionsButton = createMediaButton({
	displayName: "CaptionsButton",
	core: CaptionsButtonCore,
	stateAttrMap: CaptionsButtonDataAttrs,
	selector: selectTextTrack,
	action: (core, state) => core.toggle(state),
	hotkeyAction: "toggleSubtitles",
	isSupported: (state) => !state.hidden
});
//#endregion
export { CaptionsButton };

//# sourceMappingURL=component.js.map